import { authenticatedFetch } from '../../../api/utils/request';

export default async function getUsers(setErrorMessage) {
    const onError = () => setErrorMessage('No se pueden obtener usuarios');
    return await authenticatedFetch('/app-user-management', onError);
}
